import { BoldLabelText } from '@/components/BoldLabelText/BoldLabelText';
import { DescriptionCol, DescriptionRow } from '@/components/Description';
import {
  TransactionItemDrawerMode,
  TransactionItemDrawerModeEnum,
  TransactionItemFormType,
} from '@/features/transaction_items/List/type';
import { useTranslation } from '@/i18n';
import { FormRadioButton, Label } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

export type Props = {
  mode: TransactionItemDrawerMode;
};

export const DateInputType: FC<Props> = memo(({ mode }) => {
  const { control, getValues } = useFormContext<TransactionItemFormType>();

  const { t } = useTranslation();

  const dateFormatTypeOptions = useMemo(() => {
    return [
      {
        label: t('transaction_items.form.date_format_type.year_month_day'),
        value: 'year_month_day',
      },
      {
        label: t('transaction_items.form.date_format_type.year_month'),
        value: 'year_month',
      },
    ];
  }, [t]);

  return (
    <DescriptionRow>
      <DescriptionCol
        label={
          <Label
            required={mode !== TransactionItemDrawerModeEnum.DETAIL}
            testId='date_format_type_label'
          >
            <BoldLabelText>
              {t('transaction_items.form.input_type')}
            </BoldLabelText>
          </Label>
        }
        labelWidth='176px'
      />
      <DescriptionCol
        value={
          <>
            {mode === TransactionItemDrawerModeEnum.DETAIL ? (
              <div>
                {t(
                  `transaction_items.form.date_format_type.${getValues(
                    'date_format_type'
                  )}`
                )}
              </div>
            ) : (
              <FormRadioButton<TransactionItemFormType>
                vertical
                control={control}
                name='date_format_type'
                inputId='date_format_type'
                options={dateFormatTypeOptions}
                testId='date_format_type'
              />
            )}
          </>
        }
      />
    </DescriptionRow>
  );
});
DateInputType.displayName = 'DateInputType';
